// Load external script dynamically
export const loadScript = (src) => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

// Format currency for display
export const formatCurrency = (amount, currency = 'INR') => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
  }).format(amount);
};

// Validate payment response
export const validatePaymentResponse = (response) => {
  const requiredFields = ['razorpay_payment_id', 'razorpay_order_id', 'razorpay_signature'];
  return requiredFields.every(field => response[field]);
};

// Handle payment success
export const handlePaymentSuccess = async (response, orderId, userId) => {
  try {
    const token = localStorage.getItem('token');
    if (!token || token === 'null' || token === 'undefined' || token.length < 10) {
      throw new Error('No valid auth token');
    }
    // Send payment verification to backend
    const apiBaseUrl = process.env.REACT_APP_API_URL || '';
    const verificationResponse = await fetch(`${apiBaseUrl}/payments/razorpay/verify`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_order_id: response.razorpay_order_id,
        razorpay_signature: response.razorpay_signature,
        order_id: orderId,
        user_id: userId
      })
    });

    const result = await verificationResponse.json();

    if (result.success) {
      return { success: true, data: result.data };
    } else {
      throw new Error(result.message || 'Payment verification failed');
    }
  } catch (error) {
    console.error('Payment verification error:', error);
    throw error;
  }
};

// Handle payment failure
export const handlePaymentFailure = (error) => {
  console.error('Payment failed:', error);
  return {
    success: false,
    error: error.description || 'Payment failed',
    code: error.code
  };
};